import {Component} from "@angular/core";
import {Card} from "../../../models/loyalty-card.model";
import {MenuItem} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'kv-loyalty-domiciliation',
  template: `
    <div class="Customers master-data">
      <div class="ui-g-12 ui-lg-12 ui-g-nopad customers-steps">
        <p-steps [style]="{'width': '100%'}" [model]="tabs" [(activeIndex)]="activeTabIndex" [readonly]="false"></p-steps>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== 0">
        <kv-loyalty-domiciliation-single
          *ngIf="activeTabIndex == 0"
        ></kv-loyalty-domiciliation-single>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== 1">
        <kv-loyalty-domiciliation-massive-range
          *ngIf="activeTabIndex == 1"
        ></kv-loyalty-domiciliation-massive-range>
      </div>

      <div class="card" [hidden]="this.activeTabIndex !== 2">
        <kv-loyalty-domiciliation-massive-store
          *ngIf="activeTabIndex == 2"
        ></kv-loyalty-domiciliation-massive-store>
      </div>
    </div>
    
      
  `
})
export class LoyaltyDomiciliationComponent {

  activeTabIndex = 0;

  tabs: MenuItem[] = []

  constructor(private translate: TranslateService) {
    this.tabs = []

    this.translate.get([
      'loyalty.domiciliation_tab_single',
      'loyalty.domiciliation_tab_massive_range',
      'loyalty.domiciliation_tab_massive_store',
    ]).subscribe(t => {

      this.tabs.push({
        label: t['loyalty.domiciliation_tab_single'],
        id:'single',
      })

      this.tabs.push({
        label: t['loyalty.domiciliation_tab_massive_range'],
        id: 'massive_range'
      })

      this.tabs.push({
        label: t['loyalty.domiciliation_tab_massive_store'],
        id: 'massive_store'
      })
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-domiciliation/loyalty-domiciliation.component.ts